var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReturnRefund(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u83DC\u5355icon/\u9000\u6B3E\u9000\u8D27") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u83DC\\u5355icon/\\u9000\\u6B3E\\u9000\\u8D27",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8D27\\u54C1\\u4FE1\\u606F"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(1.400000, 2.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3085938,12.0952148 L1.83251953,12.0952148 C0.821777344,12.0952148 0,11.2734375 0,10.2626953 L0,4.13378906 C0,3.82617188 0.0791015625,3.52001953 0.229980469,3.25048828 L1.52050781,0.938964844 C1.84277344,0.360351562 2.45654297,0 3.12011719,0 L10.0209961,0 C10.6845703,0 11.296875,0.360351562 11.6206055,0.938964844 L12.9111328,3.25048828 C13.0620117,3.52001953 13.1411133,3.82470703 13.1411133,4.13378906 L13.1411133,10.2641602 C13.1411133,11.2734375 12.3193359,12.0952148 11.3085938,12.0952148 L11.3085938,12.0952148 Z M1.37695312,3.89208984 C1.3359375,3.96679688 1.31396484,4.05029297 1.31396484,4.13525391 L1.31396484,10.2641602 C1.31396484,10.5498047 1.546875,10.7827148 1.83251953,10.7827148 L11.3085938,10.7827148 C11.5942383,10.7827148 11.8256836,10.5498047 11.8256836,10.2641602 L11.8256836,4.13378906 C11.8256836,4.04882812 11.8037109,3.96533203 11.7626953,3.890625 L10.472168,1.57910156 C10.3813477,1.41503906 10.2070312,1.31396484 10.0195312,1.31396484 L3.12011719,1.31396484 C2.93261719,1.31396484 2.75976562,1.41503906 2.66748047,1.57910156 L1.37695312,3.89208984 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1552734,4.84277344 L1.01513672,4.84277344 C0.651855469,4.84277344 0.357421875,4.54833984 0.357421875,4.18505859 C0.357421875,3.82177734 0.651855469,3.52734375 1.01513672,3.52734375 L12.1552734,3.52734375 C12.5185547,3.52734375 12.8129883,3.82177734 12.8129883,4.18505859 C12.8115234,4.54980469 12.5185547,4.84277344 12.1552734,4.84277344 Z M10.5908203,9.63574219 L5.73193359,9.63574219 C5.36865234,9.63574219 5.07421875,9.34130859 5.07421875,8.97802734 C5.07421875,8.61474609 5.36865234,8.3203125 5.73193359,8.3203125 L10.5908203,8.3203125 C10.9541016,8.3203125 11.2485352,8.61474609 11.2485352,8.97802734 C11.2485352,9.34130859 10.9541016,9.63574219 10.5908203,9.63574219 Z M10.5908203,7.40332031 L7.85449219,7.40332031 C7.49121094,7.40332031 7.19677734,7.10888672 7.19677734,6.74560547 C7.19677734,6.38232422 7.49121094,6.08789063 7.85449219,6.08789063 L10.5908203,6.08789063 C10.9541016,6.08789063 11.2485352,6.38232422 11.2485352,6.74560547 C11.2470703,7.10888672 10.9541016,7.40332031 10.5908203,7.40332031 Z",
    id: "\\u5F62\\u72B6"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnRefund);
export default __webpack_public_path__ + "static/media/returnRefund.2bce2073.svg";
export { ForwardRef as ReactComponent };